import { ReactNode } from "react";

type InvoiceTileProps = {
  icon: ReactNode;
  title: string;
  children: ReactNode;
};

export const InvoiceTile = ({ icon, title, children }: InvoiceTileProps) => (
  <div className="rounded-2xl bg-white p-8">
    <div className="flex items-center gap-2">
      {icon}
      <h3 className="my-0 text-xl font-medium text-dark">{title}</h3>
    </div>

    <div className="mt-8">{children}</div>
  </div>
);
